import intermind from '../../../index';
import { QuotaUsage } from '../types/quota.types';

export class QuotaResource {
  async listUsage(): Promise<QuotaUsage[]> {
    const { data } = await intermind.httpClient.get<QuotaUsage[]>('/billing/quotas');
    return data;
  }
}
